module.exports = __webpack_public_path__ + "media/newstyle/images/stars_3-3c192e521515e90a227bc27ef5b4fe24.svg";